var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashBox = function SvgTrashBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.5 21.75A2.25 2.25 0 0 0 3.75 24h13.5a2.25 2.25 0 0 0 2.25-2.25V6h-18v15.75Zm12.75-12a.75.75 0 1 1 1.5 0v10.5a.75.75 0 1 1-1.5 0V9.75Zm-4.5 0a.75.75 0 0 1 1.5 0v10.5a.75.75 0 1 1-1.5 0V9.75Zm-4.5 0a.75.75 0 0 1 1.5 0v10.5a.75.75 0 1 1-1.5 0V9.75Zm15-8.25h-5.625l-.44-.877A1.125 1.125 0 0 0 13.176 0H7.819a1.112 1.112 0 0 0-1.003.623l-.441.877H.75a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 .75.75h19.5a.75.75 0 0 0 .75-.75v-1.5a.75.75 0 0 0-.75-.75Z"
  })));
};
export default SvgTrashBox;